/* WLB Traum-E-Bike Finder — pure vanilla JS, no React/Babel/Tailwind. */
(function () {
  'use strict';

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'style') n.setAttribute('style', attrs[k]);
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    }
    if (kids != null) {
      if (!Array.isArray(kids)) kids = [kids];
      kids.forEach(function (c) {
        if (c == null || c === false) return;
        n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return n;
  }

  // Path stack: list of strings like ['start.alltag', 'start.alltag.stadt', ...]
  // History (for breadcrumbs / back button): [{ path, label }, ...]
  var path = 'start';
  var history = []; // [{ path, label }]

  var root, body;

  function getNode() {
    var data = window.TREE_DATA;
    if (!data) return null;
    return data[path] || null;
  }

  function go(option) {
    var nextPath = path === 'start' ? 'start.' + option.key : path + '.' + option.key;
    if (!window.TREE_DATA[nextPath]) {
      console.warn('WLB Finder: missing node for path', nextPath);
      return;
    }
    history.push({ path: path, label: option.label });
    path = nextPath;
    render();
  }
  function back() {
    if (!history.length) return;
    var prev = history.pop();
    path = prev.path;
    render();
  }
  function reset() {
    path = 'start';
    history = [];
    render();
  }

  function questionView(node) {
    var step = history.length + 1;
    var totalEstimate = 4; // approximate depth — friendlier than no progress

    var optionsRow = el('div', { class: 'wlb-fn-options' });
    node.options.forEach(function (opt) {
      var card = el('button', {
        type: 'button', class: 'wlb-fn-option',
        onclick: function () { go(opt); }
      });
      // Illustration
      if (window.WlbFinderIllos && window.WlbFinderIllos.has(opt.key)) {
        var illoWrap = el('div', { class: 'wlb-fn-option-illo' });
        illoWrap.innerHTML = window.WlbFinderIllos.render(opt.key, '#0d8e8c');
        card.appendChild(illoWrap);
      }
      card.appendChild(el('div', { class: 'wlb-fn-option-label' }, opt.label));
      if (opt.blurb) card.appendChild(el('div', { class: 'wlb-fn-option-blurb' }, opt.blurb));
      optionsRow.appendChild(card);
    });

    var crumb = el('div', { class: 'wlb-fn-crumb' });
    crumb.appendChild(el('button', {
      type: 'button', class: 'wlb-fn-crumb-link',
      onclick: function () { reset(); }
    }, 'Start'));
    history.forEach(function (h, i) {
      crumb.appendChild(el('span', { class: 'wlb-fn-crumb-sep' }, '›'));
      crumb.appendChild(el('span', { class: 'wlb-fn-crumb-step' }, h.label));
    });

    var head = el('div', { class: 'wlb-fn-head' }, [
      el('div', { class: 'wlb-fn-head-row' }, [
        history.length
          ? el('button', {
              type: 'button', class: 'wlb-fn-back',
              onclick: back
            }, '← Zurück')
          : el('span', { class: 'wlb-fn-progress' }, 'Frage ' + step + ' / ~' + totalEstimate),
        history.length ? el('span', { class: 'wlb-fn-progress' }, 'Frage ' + step + ' / ~' + totalEstimate) : null
      ]),
      crumb
    ]);

    return el('div', { class: 'wlb-fn-question' }, [
      head,
      el('h2', { class: 'wlb-fn-q-title' }, node.question),
      node.subtitle ? el('p', { class: 'wlb-fn-q-sub' }, node.subtitle) : null,
      optionsRow
    ]);
  }

  function resultView(node) {
    var r = node.result;
    var bikesGrid = el('div', { class: 'wlb-fn-bikes' });
    (r.bikes || []).forEach(function (b) {
      var card = el(b.url ? 'a' : 'div', b.url ? {
        class: 'wlb-fn-bike',
        href: b.url, target: '_blank', rel: 'noopener'
      } : { class: 'wlb-fn-bike' }, [
        b.badge ? el('div', { class: 'wlb-fn-bike-badge' }, b.badge) : null,
        (function () {
          var img = el('img', { alt: (b.brand || '') + ' ' + (b.model || ''), loading: 'lazy', class: 'wlb-fn-bike-img' });
          var handle = window.WLBImg ? window.WLBImg.handleFromUrl(b.url) : '';
          if (window.WLBImg) { window.WLBImg.set(img, handle, b.image); }
          else if (b.image) { img.src = b.image; }
          return el('div', { class: 'wlb-fn-bike-img-wrap' }, [img]);
        })(),
        el('div', { class: 'wlb-fn-bike-brand' }, b.brand || ''),
        el('div', { class: 'wlb-fn-bike-model' }, b.model || ''),
        b.price ? el('div', { class: 'wlb-fn-bike-price' }, 'ab ' + b.price.toLocaleString('de-DE') + ' €') : null
      ]);
      bikesGrid.appendChild(card);
    });

    var reasoningList = el('ul', { class: 'wlb-fn-reasoning' });
    (r.reasoning || []).forEach(function (line) {
      reasoningList.appendChild(el('li', null, line));
    });

    return el('div', { class: 'wlb-fn-result' }, [
      el('div', { class: 'wlb-fn-result-kicker' }, 'Dein Match'),
      el('h2', { class: 'wlb-fn-result-type' }, r.type || ''),
      r.tagline ? el('p', { class: 'wlb-fn-result-tagline' }, r.tagline) : null,
      el('div', { class: 'wlb-fn-result-section' }, [
        el('div', { class: 'wlb-fn-result-section-title' }, 'Warum dieses Bike zu dir passt'),
        reasoningList
      ]),
      r.battery_label ? el('div', { class: 'wlb-fn-result-battery' }, r.battery_label) : null,
      el('div', { class: 'wlb-fn-result-section' }, [
        el('div', { class: 'wlb-fn-result-section-title' }, 'Drei Modelle aus unserem Sortiment'),
        bikesGrid
      ]),
      el('div', { class: 'wlb-fn-result-actions' }, [
        el('button', { type: 'button', class: 'wlb-fn-restart', onclick: reset }, '↺ Nochmal von vorne')
      ])
    ]);
  }

  function render() {
    if (!body) return;
    body.innerHTML = '';
    var node = getNode();
    if (!node) {
      body.appendChild(el('div', { class: 'wlb-fn-error' }, 'Daten konnten nicht geladen werden.'));
      return;
    }
    body.appendChild(node.result ? resultView(node) : questionView(node));
  }

  function init() {
    root = document.getElementById('wlb-finder-root');
    if (!root) return;
    if (!window.TREE_DATA) {
      root.innerHTML = '<div class="wlb-fn-error">Frage-Baum konnte nicht geladen werden.</div>';
      return;
    }
    root.innerHTML = '';
    body = el('div', { class: 'wlb-fn-body' });
    root.appendChild(body);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
